import compose from 'lodash/fp/compose';

import { withDocumentTitle } from '../generic/DocumentTitle';
import api from '../REST/api';
import withResolved from '../REST/with-resolved';
import WaitForCampaignCreation from './WaitForCampaignCreation';

export default compose(
  withResolved({
    query: api.getCampaign,
    deriveQueryArgs: ({ match }) => ({ id: match.params.id }),
    as: 'initialCampaign',
  }),
  withDocumentTitle(({ initialCampaign }) => initialCampaign.name),
)(WaitForCampaignCreation);
